import AppButton from "@/components/AppButton.vue";
import ButtonCard from "@/components/ButtonCard.vue";
import HeaderFluxo from "@/components/HeaderFluxo.vue";
import HeaderRelease from "@/components/HeaderRelease.vue";
import InputText from "@/components/InputText.vue";
import ListDefault from "@/components/ListDefault.vue";
import ModalCodigo from "@/components/ModalCodigo.vue";
import OptionCollapse from "@/components/OptionCollapse.vue";
import OptionCollapseParent from "@/components/OptionCollapseParent.vue";
import TextLink from "@/components/TextLink.vue";
import Request from "@/ts/Request";
import Util from "@/ts/Util";
import HeaderColor from "orders-module/src/components/HeaderColor.vue";
import { Component, Vue } from "vue-property-decorator";
import { TYPE } from "vue-toastification";

@Component({
  components: {
    ButtonCard,
    TextLink,
    InputText,
    AppButton,
    ModalCodigo,
    HeaderFluxo,
    ListDefault,
    OptionCollapse,
    OptionCollapseParent,
    HeaderRelease,
    HeaderColor,
  },
})
export default class RegisteredCards extends Vue {
  cards: any = JSON.parse(sessionStorage.getItem("CREDIT_CARDS") || "[]");
  cardsParent: any = sessionStorage.getItem("CARDS_PARENT")
    ? JSON.parse(sessionStorage.getItem("CARDS_PARENT") || "{}")
    : null;
  CREDIT_CARD_ID = -1;
  LAST_NUMBERS = 0;
  FLAG = "";
  showModal = false;
  paymentMethodSelected: any = sessionStorage.getItem("METHOD_SELECTED") || "";
  fullMethodSelected: any = JSON.parse(
    sessionStorage.getItem("FULL_METHOD_SELECTED") || "{}"
  );
  allPaymentMethods: Array<object> = JSON.parse(
    sessionStorage.getItem("ALL_PAYMENT_METHODS") || "[]"
  );
  nrorg: any = sessionStorage.getItem("NRORG");
  showPaymentVoucher = -1;
  backButton: any = {
    iconClass: "fas",
    icon: "chevron-left",
    show: true,
    callback: this.goBack,
  };
  store: any = JSON.parse(sessionStorage.getItem("STORE") || "{}");

  mounted() {
    Util.setBackButtonBehavior(this.goBack);
    this.getCreditCards();
    this.getStoresPaymentType();
  }

  getCreditCards() {
    try {
      const self = this;
      const req = new Request();
      req.body = {
        USER_ID: sessionStorage.getItem("USER_ID") || "",
        TOKEN: sessionStorage.getItem("TOKEN") || "",
        NRORG: sessionStorage.getItem("NRORG"),
        STORE_ID: this.store.id ? this.store.id : null,
      };
      req.route = "getValidCreditCard";
      req.callbackSuccess = function (response: any) {
        self.cards = response.creditcards;
        self.cardsParent = response.creditcardFromParent;

        if (self.cardsParent) {
          sessionStorage.setItem(
            "CARDS_PARENT",
            JSON.stringify(self.cardsParent)
          );
        } else {
          sessionStorage.setItem("CARDS_PARENT", "");
        }
        sessionStorage.setItem(
          "CREDIT_CARDS",
          JSON.stringify(self.cards || [])
        );
      };
      req.callbackError = function (error: any) {
        console.log(error);
      };
      req.blockTouchEvents = false;
      req.showLoader = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  getStoresPaymentType() {
    try {
      const self = this;
      const req = new Request();
      req.route = "getStoresPaymentType";
      req.body = {
        USER_ID: sessionStorage.getItem("USER_ID") || "",
        TOKEN: sessionStorage.getItem("TOKEN") || "",
        NRORG: sessionStorage.getItem("NRORG"),
      };
      req.callbackSuccess = function (response: any) {
        for (let i = 0; i < response.payments.length; i++) {
          const store = response.payments[i];
          for (let x = 0; x <= store.paymentMethods.length; x++) {
            const payments = store.paymentMethods[x];
            if (payments.PAYMENT_METHOD.includes("VOUCHER")) {
              self.showPaymentVoucher = 0;
              break;
            }
          }
          if (self.showPaymentVoucher == 0) {
            break;
          }
        }
      };
      req.callbackError = function (error: any) {
        console.log(error);
      };
      req.blockTouchEvents = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  deleteCC() {
    try {
      const self = this;
      const req = new Request();
      req.body = {
        CREDITCARD_ID: this.CREDIT_CARD_ID,
        USER_ID: sessionStorage.getItem("USER_ID") || "",
        TOKEN: sessionStorage.getItem("TOKEN") || "",
        NRORG: sessionStorage.getItem("NRORG"),
      };
      req.route = "deleteCC";
      req.visibilityOptions = { success: false, error: false, loading: true };
      req.callbackSuccess = function (response: any) {
        self.fechaModal();
        self.getCreditCards();
        // req.showSuccessMessage('Cartão removido com sucesso!');
        this.$toast("Cartão removido com sucesso!", {
          type: TYPE.SUCCESS,
        });
        sessionStorage.setItem("METHOD_SELECTED", "");
        sessionStorage.setItem("FULL_METHOD_SELECTED", "{}");
      };
      req.callbackError = function (error: any) {
        req.showErrorMessage(
          "Ocorreu um erro desconhecido. Por favor, tente mais tarde"
        );
        console.log(error);
      };
      req.loadingMessage = "Removendo o cartão...";
      req.blockTouchEvents = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  lastNumberCard(lastNumbers: any) {
    const lastNumber =
      "0000".substring(0, 4 - String(lastNumbers).length) + lastNumbers;
    return lastNumber;
  }

  mostraModal(id: number, cardNumber: number, flag: string) {
    this.CREDIT_CARD_ID = id;
    this.LAST_NUMBERS = cardNumber;
    this.FLAG = flag;
    this.showModal = true;
  }

  fechaModal() {
    this.showModal = false;
  }

  deletarCard(cardId: number) {
    const card = this.cards.find((c: any) => c.ID == cardId);
    this.CREDIT_CARD_ID = cardId;
    this.FLAG = card.FLAG;
    this.LAST_NUMBERS = card.LAST_NUMBERS;
    this.showModal = true;
  }

  goBack() {
    this.$router.go(-1);
  }

  goTo() {
    this.$router.push({ name: "AddCard" });
  }

  goToAddCard() {
    sessionStorage.setItem("FLAG_VR", "");
    this.$router.push({ name: "AddCard" });
  }

  goToAddVr() {
    sessionStorage.setItem("FLAG_VR", "VOUCHER");
    this.$router.push({ name: "AddCard" });
  }

  goToExtrato() {
    this.$router.push({ name: "Extrato" });
  }

  changeMainCard(id: number) {
    const elem: any = $("#check" + id)[0];
    if (elem.checked == true) {
      try {
        const self = this;
        const req = new Request();
        req.body = {
          CREDITCARD_ID: id || "",
          USER_ID: sessionStorage.getItem("USER_ID") || "",
          TOKEN: sessionStorage.getItem("TOKEN") || "",
          NRORG: sessionStorage.getItem("NRORG"),
        };
        req.route = "setMainCreditCard";
        req.callbackSuccess = function (response: any) {
          self.getCreditCards();
        };
        req.callbackError = function (error: any) {
          console.log(error);
        };
        req.blockTouchEvents = false;
        req.send();
      } catch (e) {
        console.log(e);
      }
    } else {
      elem.checked = true;
    }
  }
}
